import {
    Banner,
    BannerDescription,
    BannerEyebrow,
    BannerImage,
    BannerImageContainer,
    BannerLinks,
    BannerSecondaryImage,
    BannerSecondaryImageContainer,
    BannerText,
    BannerTextContainer,
    BannerTitle,
    Box,
    Button,
    FluidImage,
    H1,
    Hidden,
    P,
} from '@vp/swan';
import { __, __image } from '@99designs/i18n';
import { CloudinaryImage } from '../../CloudinaryImage';
import { useProductPricingContext } from '../../ProductPricingContext';
import { Price } from './Price';

interface HeaderProps {
    browseDesignServicesCtaOnClick: () => void;
    howItWorksCtaOnClick: () => void;
}

export function Header({ browseDesignServicesCtaOnClick, howItWorksCtaOnClick }: HeaderProps) {
    const { lowestPrice, priceLoading } = useProductPricingContext();

    return (
        <Banner editorial twoImages textBoxHorizontalAlign="center" backgroundColor="warm-white">
            <BannerTextContainer>
                <BannerText>
                    <BannerEyebrow>{__('Design Services')}</BannerEyebrow>
                    <BannerTitle as={H1} fontSkin="title-headline" fontWeight="normal">
                        We'll do the design, you deck the halls
                    </BannerTitle>
                    <BannerDescription>
                        <P>
                            Our pro designers can turn your ideas into beautiful, custom products -
                            perfectly crafted for any occasion.
                        </P>
                    </BannerDescription>
                    <Box fontSkin="title-item">
                        <Price price={lowestPrice} loading={priceLoading} />
                    </Box>
                    <BannerLinks>
                        <Button skin="primary" onClick={browseDesignServicesCtaOnClick}>
                            {__('Browse design services')}
                        </Button>
                        <Button skin="secondary" onClick={howItWorksCtaOnClick}>
                            {__('How it works')}
                        </Button>
                    </BannerLinks>
                </BannerText>
            </BannerTextContainer>
            <BannerImageContainer>
                <BannerImage>
                    <Hidden xs sm md style={{ height: '100%' }}>
                        <CloudinaryImage
                            render={(props) => (
                                <FluidImage
                                    src={props.src}
                                    srcSet={props.srcSet}
                                    alt=""
                                    role="presentation"
                                />
                            )}
                            imagePath={__image('expert_services/HubPage/holiday/hero-image-right')}
                            width={686}
                        />
                    </Hidden>
                    <Hidden lg xl style={{ height: '100%' }}>
                        <CloudinaryImage
                            render={(props) => (
                                <FluidImage
                                    src={props.src}
                                    srcSet={props.srcSet}
                                    alt=""
                                    role="presentation"
                                />
                            )}
                            imagePath={__image('expert_services/HubPage/holiday/hero-image')}
                            width={686}
                        />
                    </Hidden>
                </BannerImage>
            </BannerImageContainer>
            <BannerSecondaryImageContainer>
                <BannerSecondaryImage imageFocalPoint="right center">
                    <CloudinaryImage
                        render={(props) => (
                            <FluidImage
                                src={props.src}
                                srcSet={props.srcSet}
                                alt=""
                                role="presentation"
                            />
                        )}
                        imagePath={__image('expert_services/HubPage/holiday/hero-image-left')}
                        width={686}
                    />
                </BannerSecondaryImage>
            </BannerSecondaryImageContainer>
        </Banner>
    );
}
